__turbopack_context__.v({
  "iconSlot": "MUKeGG_iconSlot",
  "label": "MUKeGG_label",
  "styledCta": "MUKeGG_styledCta" + " " + __turbopack_context__.i(931616)["ctaStyle"],
});
